<div class="product-end-prize">
  <div class="product-end-prize-container">
    <div class="product-end-prize-title">
      <div class="product-end-prize-subtitle"> End prize </div>
      <div class="product-end-prize-value"> {{ endPrize }} </div>
    </div>

    <div class="product-end-prize-separator"></div>

    <div class="product-end-prize-description">
      {{ endPrizeDescription }}
      <span class="product-end-prize-description-bold">end prize</span>
      draw.
    </div>
    <div
      class="product-end-prize-description"
      *ngIf="drawMethod === drawMethods.Live"
    >
      Interactive live draw on our
      <a [href]="facebookUrl" target="_blank">Facebook</a>
      <ng-container *ngIf="youtubeUrl">
        and <a [href]="youtubeUrl" target="_blank">Youtube</a>
      </ng-container>
      page.
    </div>

    <div class="product-end-prize-draw">
      <span>{{
        drawMethod === drawMethods.Auto ? 'Auto-draw' : 'Live-draw'
      }}</span>
      <svg-icon
        *ngIf="drawMethod === drawMethods.Auto"
        name="info-icon"
        class="product-end-prize-draw-icon"
        fill="none"
        (click)="infoEvent.emit()"
      ></svg-icon>
      <div class="product-end-prize-draw-timer">
        <span>{{ daysLeft }}d</span>
        <span [ngClass]="{ 'disable-timer-separator': !showTimerSeparator }">
          :
        </span>
        <span>{{ hoursLeft }}h</span>
        <span [ngClass]="{ 'disable-timer-separator': !showTimerSeparator }">
          :
        </span>
        <span>{{ minutesLeft }}m</span>
      </div>
    </div>
  </div>
  <div class="product-end-prize-info">
    {{ endPrizeInfo }}
  </div>
</div>
